<template>
  <div class="heading-3" ref="heading3">
    <slot>Lorem ipsum dolor sit amet</slot>
  </div>
</template>

<script>
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default {
  name: "Heading3",
  methods: {
    setupScrollTrigger() {
      const triggerElement = this.$refs.heading3;

      gsap.from(triggerElement, {
        scrollTrigger: {
          trigger: triggerElement,
          start: 'top 50%', // Trigger animation when element is 80% in view
          end: 'bottom 0%', // Animation ends when element is 20% out of view
          toggleActions: 'play none none none', // Defines the behavior of the animation on entering/leaving the trigger area
          onEnter: () => {
            triggerElement.classList.add('heading-3-hover-after')
          },
          onLeaveBack: () => {
            triggerElement.classList.remove('heading-3-hover-after')
          }
        }
      });
    }
  },
  mounted() {
    gsap.registerPlugin(ScrollTrigger);
    this.setupScrollTrigger();
  }

}
</script>

<style scoped>
.heading-3 {
  color: var(--primary);
  position: relative;
  outline: none !important;
  transition: 0.2s;
  width: fit-content;
}

.heading-3::after {
  content: "";
  background-color: var(--primary);
  position: absolute;
  bottom: 0;
  left: 0;
  height: 5px;
  width: 0;
  transition: 1s;
}


.heading-3:after {
  background-color: var(--secondary);
  color: var(--secondary);
  border-radius: 50px;
  margin: -10px 0;
}

.heading-3-hover-after:after {
  width: 100%;
  transition: 1.5s;
}

</style>